import { render } from "./CustomISO.vue?vue&type=template&id=24c79a6c"
import script from "./CustomISO.vue?vue&type=script&lang=js"
export * from "./CustomISO.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__